import React, { useState, useEffect, useRef } from 'react';

const MultiSelect = ({ label, options, value, onChange, required }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [isOpen]);

  const toggle = (optVal) => {
    const numVal = Number(optVal);
    if (value.includes(numVal)) {
      onChange(value.filter((v) => v !== numVal));
    } else {
      onChange([...value, numVal]);
    }
  };

  const selectedOptions = options.filter((o) => value.includes(Number(o.value)));
  const count = selectedOptions.length;

  return (
    <div className="form-multiselect-wrap" ref={containerRef}>
      <label className="form-label">
        {label}
        {required && <span className="req">*</span>}
        {count > 0 && <span className="form-multiselect-count">{count}</span>}
      </label>

      <div
        className={`form-multiselect-trigger${isOpen ? ' is-open' : ''}`}
        onClick={() => setIsOpen((p) => !p)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') setIsOpen((p) => !p);
          if (e.key === 'Escape') setIsOpen(false);
        }}
      >
        {count === 0 ? (
          <span className="form-multiselect-placeholder">Select {label}…</span>
        ) : (
          <div className="form-multiselect-chips">
            {selectedOptions.map((o) => (
              <span key={o.value} className="form-multiselect-chip">
                {o.label}
                <button
                  type="button"
                  className="form-multiselect-chip-x"
                  onClick={(e) => { e.stopPropagation(); toggle(o.value); }}
                  aria-label={`Remove ${o.label}`}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
        <svg
          className={`form-multiselect-arrow${isOpen ? ' rotated' : ''}`}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {isOpen && (
        <div className="form-multiselect-dropdown">
          {options.length === 0 ? (
            <div className="form-multiselect-empty">No options available</div>
          ) : (
            options.map((o) => {
              const isSelected = value.includes(Number(o.value));
              return (
                <label
                  key={o.value}
                  className={`form-multiselect-option${isSelected ? ' is-selected' : ''}`}
                  onClick={(e) => { e.preventDefault(); toggle(o.value); }}
                >
                  <span className={`form-multiselect-optcheck${isSelected ? ' checked' : ''}`}>
                    {isSelected && (
                      <svg viewBox="0 0 12 12" fill="none">
                        <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </span>
                  <span>{o.label}</span>
                </label>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
